var render = function render(){var _vm=this,_c=_vm._self._c;return _c('appointment-complete',{attrs:{"main-page-title":"Manejo de Citas","main-page-routes":[
    'Inicio',
    'Estudiante',
    'Citas',
    'Manejo de Citas',
    'Completar Cita'
  ],"get-appointment-info":_vm.getAppointmentInfo,"get-specialist-practitioners":_vm.getSpecialistPractitioners,"get-appointment-municipalities":_vm.getMunicipalities,"get-appointment-locations":_vm.getAppointmentLocations,"get-specialist-by-location":_vm.getSpecialistByLocation,"complete-appointment":_vm.completeAppointment,"get-frequency-type":_vm.getFrequencyType,"get-service-modalities":_vm.getServiceModalities,"get-therapy-durations":_vm.getTherapyDurations,"get-appointment-therpies":_vm.getAppointmentTherpies,"get-services":_vm.getServices,"getReevaluationTimes":_vm.getReevaluationTimes}})
}
var staticRenderFns = []

export { render, staticRenderFns }